import { CustomerActionTypes } from '../../../enums/ActionEnums';
export const initialState = {};
export const loadCustomerReducer = (initialData = {}) => {
    const initialReducerState = Object.assign(Object.assign({}, initialState), initialData);
    return (state = initialReducerState, action) => {
        switch (action.type) {
            case CustomerActionTypes.GET_PROFILE:
                return Object.assign(Object.assign({}, state), { profile: {} });
            case CustomerActionTypes.SET_PROFILE:
                return Object.assign(Object.assign({}, state), { profile: action.payload });
            case CustomerActionTypes.GET_DELIVERY_ADDRESSES:
                return Object.assign(Object.assign({}, state), { deliveryAddress: {} });
            case CustomerActionTypes.SET_DELIVERY_ADDRESSES:
                return Object.assign(Object.assign({}, state), { billingAddress: action.payload.customerAddress, deliveryAddresses: action.payload.deliveryAddresses });
            default:
                return state;
        }
    };
};
export const customerReducer = loadCustomerReducer();
